import React from 'react';
import { motion } from 'framer-motion';
import CyberButton from "../UI/CyberButton";
import NeonText from '../UI/NeonText';
import {scrollVariants, useScrollAnimation} from "../../hooks/useScrollAnimation";

const Footer = () => {
    const { ref, controls } = useScrollAnimation();

    const currentYear = new Date().getFullYear();

    return (
        <motion.footer
            className="footer"
            ref={ref}
            initial="hidden"
            animate={controls}
            variants={scrollVariants}
        >
            <div className="footer__content">
                {/* Sección Principal */}
                <div className="footer__main">
                    <div className="footer__brand">
                        <NeonText variant="cyan" size="large">
                            TECH_ANIME
                        </NeonText>
                        <p className="footer__description">
                            Líderes en innovación tecnológica y desarrollo de soluciones
                            cyberpunk para el futuro digital.
                        </p>
                        <div className="footer__status">
                            <div className="status-indicator">
                                <span className="status-dot"></span>
                                SISTEMA OPERATIVO
                            </div>
                            <span className="status-version">v2.1.4</span>
                        </div>
                    </div>

                    <div className="footer__links">
                        <div className="footer__column">
                            <h4 className="footer__title">Navegación</h4>
                            <ul className="footer__list">
                                <li><a href="/" className="footer__link">Inicio</a></li>
                                <li><a href="/services" className="footer__link">Servicios</a></li>
                                <li><a href="/portfolio" className="footer__link">Portafolio</a></li>
                                <li><a href="/about" className="footer__link">Nosotros</a></li>
                                <li><a href="/contact" className="footer__link">Contacto</a></li>
                            </ul>
                        </div>

                        <div className="footer__column">
                            <h4 className="footer__title">Servicios</h4>
                            <ul className="footer__list">
                                <li><a href="#" className="footer__link">IA & Machine Learning</a></li>
                                <li><a href="#" className="footer__link">Ciberseguridad</a></li>
                                <li><a href="#" className="footer__link">Realidad Extendida</a></li>
                                <li><a href="#" className="footer__link">Blockchain</a></li>
                                <li><a href="#" className="footer__link">Neuro-Interfaces</a></li>
                            </ul>
                        </div>

                        <div className="footer__column">
                            <h4 className="footer__title">Conectar</h4>
                            <ul className="footer__list">
                                <li><a href="#" className="footer__link">GitHub</a></li>
                                <li><a href="#" className="footer__link">LinkedIn</a></li>
                                <li><a href="#" className="footer__link">Twitter</a></li>
                                <li><a href="#" className="footer__link">Discord</a></li>
                                <li><a href="#" className="footer__link">Matrix</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Sección de Contacto */}
                <div className="footer__contact">
                    <div className="contact__info">
                        <h4 className="footer__title">Iniciar Proyecto</h4>
                        <p className="contact__description">
                            ¿Listo para llevar tu idea al siguiente nivel?
                            Nuestro sistema está en línea y esperando tu comando.
                        </p>
                        <div className="contact__methods">
                            <div className="contact__method">
                                <span className="method__label">EMAIL:</span>
                                <span className="method__value">contact@techanime.dev</span>
                            </div>
                            <div className="contact__method">
                                <span className="method__label">MATRIX:</span>
                                <span className="method__value">@techanime:matrix.org</span>
                            </div>
                            <div className="contact__method">
                                <span className="method__label">SIGNAL:</span>
                                <span className="method__value">+1-555-TECH-AI</span>
                            </div>
                        </div>
                    </div>

                    <div className="contact__action">
                        <CyberButton variant="magenta" size="large">
                            INICIAR COMUNICACIÓN
                        </CyberButton>
                    </div>
                </div>

                {/* Línea inferior */}
                <div className="footer__bottom">
                    <div className="footer__legal">
                        <span>&copy; {currentYear} TECH_ANIME SYSTEMS. TODOS LOS DERECHOS RESERVADOS.</span>
                        <span>// SISTEMA PROTEGIDO POR LEY DE PROPIEDAD INTELECTUAL</span>
                    </div>

                    <div className="footer__system">
                        <div className="system-info">
                            <span className="system-data">USUARIOS CONECTADOS: 247</span>
                            <span className="system-data">LATENCIA: 12ms</span>
                            <span className="system-data">UPTIME: 99.98%</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Efectos de fondo del footer */}
            <div className="footer__background">
                <div className="footer__grid"></div>
                <div className="footer__scanline"></div>
            </div>
        </motion.footer>
    );
};

export default Footer;